import React, { useEffect } from 'react';
import classNames from 'classnames';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { responseLogWithNotification } from '../../../utils/utils';
import { Button, Icons, Row } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import { clearGlobalPopUpWrapper } from '../actions';
import { POPUP_LIST_NAME } from '../../../configs';
import { dateFormatter, infoFormatterIntl } from '../../../utils/formatters';
import TimerLoader from '../../../components/base/Loader/TimerLoader';
import { getRegisterData } from '../../RegionRegistry/reducer';
import { loadCarrierById } from '../../RegionRegistry/actions';

export default function CarrierDetailsPopUp(props) {
  const {
    id,
  } = props;
  const { formatMessage } = useIntl();
  const dispatch = useDispatch();
  const {
    currentCarrier = {},
    loadingCurrentSZLT,
  } = useSelector(getRegisterData);

  const {
    organization_name,
    record_number,
    inn,
    ogrn,
    created_at,
    end_date,
    phone,
    email,
    web_site,
    legal_address,
    activity_address,
    employment_contract_number,
    employment_contract_date,
  } = currentCarrier;

  useEffect(() => {
    dispatch(loadCarrierById(id)).catch(responseLogWithNotification);
  }, [id]);

  return (
    <div className={classNames('full-view custom-scroll-theme')}>
      <TimerLoader loading={loadingCurrentSZLT} />
      <div className="full-view-header">
        <div>{formatMessage({ id: 'driver.card.menu.carrier.details' })}</div>
        <Icons onClick={() => dispatch((clearGlobalPopUpWrapper({ key: POPUP_LIST_NAME.CARRIER_DETAIL, id })))} customIcon icon="close" />
      </div>
      <div className="full-view-content">
        <Row className="row-cols-2">
          {infoFormatterIntl('organization_name', organization_name, {}, 'organization_name')}
          {infoFormatterIntl('record_number', record_number, {}, 'record_number')}
        </Row>
        <Row className="row-cols-2">
          {infoFormatterIntl('inn', inn, {}, 'inn')}
          {infoFormatterIntl('ogrn_ogrnip', ogrn, {}, 'ogrn')}
        </Row>
        <Row className="row-cols-2">
          {infoFormatterIntl('created_at', dateFormatter(created_at), {}, 'created_at')}
          {infoFormatterIntl('end_date', dateFormatter(end_date), {}, 'end_date')}
        </Row>
        <Row className="row-cols-2">
          {infoFormatterIntl('pd.email', email, {}, 'pd.email')}
          {infoFormatterIntl('phone', phone, {}, 'phone')}
        </Row>
        <Row className="row-cols-1">
          {infoFormatterIntl('web_site', web_site, {}, 'web_site')}
        </Row>
        <Row className="row-cols-1">
          {infoFormatterIntl('legal_address', legal_address, {}, 'legal_address')}
        </Row>
        <Row className="row-cols-1">
          {infoFormatterIntl('activity_address', activity_address, {}, 'activity_address')}
        </Row>
        <Row className="row-cols-2">
          {infoFormatterIntl('employment_contract_number', employment_contract_number, {}, 'employment_contract_number')}
          {infoFormatterIntl('employment_contract_date', dateFormatter(employment_contract_date), {}, 'employment_contract_date')}
        </Row>
      </div>
      <div className="full-view-footer">
        <Button variant="primary">
          {formatMessage({ id: 'return_registry_carrier' })}
        </Button>
      </div>
    </div>
  );
}
